import React from 'react';
import { getSolicitationInfoPdf } from '../../../utils/fileDownload';

export const columns = [
  {
    Header: 'Solicitation ID',
    accessor: 'id',
    width: 125,
    Cell: cellProps => (
      <span>
        <a href onClick={() => { getSolicitationInfoPdf(`${cellProps.value}`) }} > {cellProps.value} </a>
      </span>
    ),
    Cell2: row => (
      <a
        href={`https://dibbs2.bsm.dla.mil/Downloads/RFQ/${row.value.slice(-1)}/${row.value}.PDF`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.value}
      </a>
    ),
  },
  {
    Header: 'Casting Type',
    accessor: 'castingType',
  },
  {
    Header: 'NSN',
    accessor: 'purchaseRequest.nsnPart',
    width: 150,
  },
  {
    Header: 'Nomenclature',
    accessor: 'purchaseRequest.nomenclature',
    width: 200,
  },

  {
    Header: 'Date Issued',
    accessor: 'issueDate',
  },
  {
    Header: 'Purchase Req #',
    accessor: 'purchaseRequest.number',
  },
  {
    Header: 'Quantity',
    accessor: 'purchaseRequest.quantity',
  },
  {
    Header: 'UI',
    accessor: 'um',
    width: 50,
  },
  {
    Header: 'SRVA',
    accessor: 'srva',
    width: 75,
  },
  {
    Header: 'SetAside',
    accessor: 'setAside',
    width: 80,
  },
  {
    id: 'material',
    Header: 'Materials',
    accessor: 'materialsMethods',
    Cell: cellProps => {
      console.log(cellProps);
      const arr = [];
      cellProps.value.forEach(element => {
        arr.push(
          <div>
            {element.material}
          </div>,
        );
      });
      return arr;
    },
    width: 125,
  },
  {
    id: 'method',
    Header: 'Methods',
    accessor: 'materialsMethods',
    Cell: cellProps => {
      console.log(cellProps);
      const arr = [];
      cellProps.value.forEach(element => {
        arr.push(
          <div>
            {element.method}
          </div>,
        );
      });
      return arr;
    },
    width: 240,
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/InformationGrid/gridConfig.jsx